import { ControlledCheckbox, ControlledRadioGroup } from "@dune/ui";
import { ColumnDef } from "@tanstack/react-table";
import { useFormContext } from "react-hook-form";
import { ControlledPriceInput } from "../../../components/inputs/ControlledPriceInput";

export type AccessibleProduct = {
	name: string;
	authorized: string;
	commission: string;
	minCommission: string;
	maxCommission: string;
	isReunionDepartmentAuthorized: boolean;
};

export const accessibleProductsColumns: ColumnDef<AccessibleProduct>[] = [
	{
		accessorKey: "name",
		header: "Produit",
		cell: ({ row }) => (
			<div className="truncate min-w-0" title={row.original.name}>
				{row.original.name}
			</div>
		),
	},
	{
		accessorKey: "authorized",
		header: "Oui/Non",
		cell: ({ row }) => {
			const form = useFormContext();
			const name = `accessibleProducts.${row.index}.authorized`;
			return (
				<div className="min-w-fit">
					<ControlledRadioGroup
						control={form.control}
						defaultValue={"false"}
						name={name}
						items={[
							{
								id: `authorized-${row.index}-true`,
								value: "true",
								label: "Oui",
							},
							{
								id: `authorized-${row.index}-false`,
								value: "false",
								label: "Non",
							},
						]}
						isFilled
					/>
				</div>
			);
		},
	},
	{
		accessorKey: "commission",
		header: "Commission (en %)",
		cell: ({ row }) => {
			const form = useFormContext();
			const name = `accessibleProducts.${row.index}.commission`;
			return (
				<div className="min-w-[100px] max-w-[150px]">
					<ControlledPriceInput
						control={form.control}
						name={name}
						min="0"
						max="100"
					/>
				</div>
			);
		},
	},
	{
		accessorKey: "minCommission",
		header: "Commission minimum (en €)",
		cell: ({ row }) => {
			const form = useFormContext();
			const name = `accessibleProducts.${row.index}.minCommission`;
			return (
				<div className="min-w-[100px] max-w-[150px]">
					<ControlledPriceInput control={form.control} name={name} min="0" />
				</div>
			);
		},
	},
	{
		accessorKey: "maxCommission",
		header: "Commission maximum (en €)",
		cell: ({ row }) => {
			const form = useFormContext();
			const name = `accessibleProducts.${row.index}.maxCommission`;
			return (
				<div className="min-w-[100px] max-w-[150px]">
					<ControlledPriceInput control={form.control} name={name} min="0" />
				</div>
			);
		},
	},
	{
		accessorKey: "isReunionDepartmentAuthorized",
		header: "Réunion (DO)",
		cell: ({ row }) => {
			const form = useFormContext();
			const name = `accessibleProducts.${row.index}.isReunionDepartmentAuthorized`;
			const doProducts = ["DO", "DO - CARAVELA", "DO - AXERIA"];
			return (
				doProducts.includes(row.original.name) && (
					<div className="flex justify-center">
						<ControlledCheckbox
							control={form.control}
							name={name}
							id={`isReunionDepartmentAuthorized-${row.index}`}
							label=""
						/>
					</div>
				)
			);
		},
	},
];
